"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remapValue = void 0;
/**
 * Remaps a value from within one range to its corresponding value in another range.
 * E.g. convert between units or proportionally scale a value.
 *
 * @param n A numeric value
 * @param from Range the value comes from
 * @param to Range you wish to remap the value onto
 * @returns The remapped numeric value
 */
var remapValue = function remapValue(n, from, to) {
  return (n - from.min) * (to.max - to.min) / (from.max - from.min) + to.min;
};
exports.remapValue = remapValue;
//# sourceMappingURL=remapValue.js.map